<template>
  <div class="order-details">
    <div v-if='loadFailed' class='failed'>
      <button type='button' class='btn' @click='getData'>再読み込み</button>
    </div>
    <div v-show='$route.name == "orderSteps"'>
      <div v-if='status == "empty"' class='order-details__empty'>Order Not found</div>
      <div v-if='status == "ok"'>
        <ul>
          <li v-for='(step, index) in order.info_steps' :key='index'>
            <router-link :to='"steps/"+links[index]'>
              <Icon v-if='step.status == 1' icon="check"/>
              <span>{{ index+1+": "+step.step_name }}</span>
              <Icon icon="chevron-right"/>
            </router-link>
          </li>
        </ul>
        <div class="floating-actions" v-if="order.quote_exists">
          <button @click='gotoQuotes' class='btn btn-orange'>
            見積り確認
          </button>
        </div>
      </div>
    </div>
    <router-view 
      v-if='$route.name != "orderSteps"'
      :order='order'>
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'OrderSteps',
  data: function() {
    return {
      order: null,
      status: null, // others: 'ok', 'empty'
      loadFailed: false,
      links: [
        "beforeworksignature",
        "beforeworkpictures",
        "afterworkpictures",
        "purchase",
        "payment"
      ]
    }
  },
  methods: {
    done: function() {
      this.$api
      .postOrderDone(this.$route.params.id)
      .then(()=>{
        this.$router.push({name: 'orders'})
      })
    },
    getData: function() {
      this.loadFailed = false;
      this.$api.getOrderSteps(this.$route.params.id)
      .then((res)=> {
        this.order = res.data.data;
        this.status = this.order ? 'ok' : 'empty';
      })
      .catch(() => {
        this.loadFailed = true;
      })
    },
    gotoQuotes: function() {
      this.$router.push({name:'quotes', params: this.$route.params});
    }
  },
  mounted: function() {
    this.$$.context({
      previous: '戻る',
      previousRouteName: 'orderDesc',
      title: "ID:"+this.$route.params.id,
      showAccountControl: true,
    });

    this.getData();
  },
  updated: function() {
    if (this.$route.name ==  'orderSteps')
    this.$$.context({
      previous: '戻る',
      previousRouteName: 'orderDesc'
    })
  },
}
</script>
<style lang="scss">
.order-details {
  margin-bottom: 100px;
  .failed {
    padding-top: 120px;
    text-align: center;
  }
  height: 100%;
  &__empty {
    padding: 16px;
    text-align: center;
  }
  ul {
    margin-bottom: 120px;
    text-align: left;
    a {
      display: block;
      text-decoration: none;
      color: inherit;
      padding: 1.5em 0;
      margin-left: 2.5em;
      position: relative;
      border-bottom: 1px solid #ddd;
      .icon {
        font-size: 1.2em;
      }
      .icon-check {
        top: 1.35em;
        position: absolute;
        left: -1.5em;
        path {fill: #36f}
      }
      .icon-chevron-right {
        float: right;
        opacity: .5;
        margin-top: .15em;
        margin-right: .25em;
      }
    }
  }
  button {
    margin: 8px auto;
  }
}
</style>